export const BUY_COLOR = 'var(--successAccent-11)'
export const SELL_COLOR = 'var(--down-9)'

export const CHART_HEIGHT = 134
export const BAR_WIDTH = 4
export const BAR_GAP = 5
export const LABEL_HEIGHT = 10
export const POINT_OUTER_SIZE = 8

export const PADDING_INLINE = 10
export const PADDING_TOP = 2 + POINT_OUTER_SIZE * 2 + 4 + LABEL_HEIGHT * 2 + 3
